module.exports = __webpack_public_path__ + "img/ic_nav_music-off-active.9ab11e55.svg";